import { defaultTheme } from "folksam-ui";

export default {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    black: "#262626",
    white: "#ffffff",
    badgeDone2: "#99cc66",
    primary1: "#c43a00",
    primary2: "#f35b1c",
    primary3: "#f5b895",
    primary4: "#fadac7",
    primary5: "#fbf2ea",
    primaryInteraction1: "#c76a31",
    primaryInteraction2: "#f35b1c",
    secondary1: "#257886",
    secondary2: "#31a3ae",
    secondary3: "#98d0d6",
    secondary4: "#bee7eb",
    secondary5: "#ebf8f2",
    secondaryInteraction1: "#447c81",
    secondaryInteraction2: "#31a3ae",
    tertiary1: "#512b2b",
    tertiary2: "#a38b80",
    tertiary3: "#d4b8a3",
    tertiary4: "#ebe7e2",
    tertiary5: "#f9f8f6",
    tertiaryInteraction1: "#b8ada6",
    tertiaryInteraction2: "#a38b80",
    quanternary1: "#c5131c",
    quanternary2: "#fdc129",
    quanternary3: "#f9ce22",
    quanternary4: "#fff3d5",
    quanternary5: "#fefad8",
    quinary1: "#4572c0",
    quinary2: "#99bbf5",
    quinary3: "#e8eff9",
    senary1: "#696969",
    senary2: "#999999",
    senary3: "#dcdcdc",
    senary4: "#f9f8f6"
  },
  fonts: {
    ...defaultTheme.fonts,
    serif: ["SwedbankSans", "SwedbankHeadline-Black", "SwedbankHeadline-Bold"],
    sans: ["Arial"],
    swedbankHeadline: ["SwedbankHeadline"],
    swedbankHeadlineBold: ["SwedbankHeadlineBold"],
    swedbankHeadlineBlack: ["SwedbankHeadlineBlack"],
    swedbankSans: ["SwedbankSans"]
  },
  fontWeights: {
    ...defaultTheme.fontWeights,
    normal: 400,
    medium: 500,
    bold: 700,
    black: 900
  },
  // borderRadius: {
  //   ...defaultTheme.borderRadius,
  //   sm: "0px"
  // },
  // TODO: Add the paddings that will be in use, below are now for testing
  padding: {
    px: "1px",
    // Folksam specific
    sm: "1.188rem",
    md: "1.5rem",
    lg: "2.5rem",
    // Scale
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "6": "1.5rem",
    "8": "2rem"
  }
};
